import React from "react";
import InputWithJson from "../component/InputWithJson.jsx";

const LayerFilter = ({layerField, index, updateField}) => {
    return (
      <InputWithJson 
        withInput={false} 
        jsonInputSetting={{
          value: layerField.filter,
          updateJsonValue: (value) => updateField(`layerFields.${index}.filter`, value),
          label: I18n.t('input_filter_json'),
          description: I18n.t('mapbox_layer_filter')
        }} 
      />
    )
}

export default LayerFilter